import HTMLColumnsStrategy from '../HTMLColumnsStrategy'

export default function BaseTasksEvAHTMLPreviewStrategy() {}

BaseTasksEvAHTMLPreviewStrategy.prototype = new HTMLColumnsStrategy();

BaseTasksEvAHTMLPreviewStrategy.prototype.init = function ( timeFormat ) {
    HTMLColumnsStrategy.prototype.init.call( this, timeFormat );
    return this;
};

BaseTasksEvAHTMLPreviewStrategy.prototype.getLevelsNumber = function () {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.getColumnsNumber = function () {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addFirstHeaderRowCells = function ( row ) {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addSecondHeaderRowCells = function ( row ) {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addThirdHeaderRowCells = function ( row ) {
    // abstract
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addColumnValues = function ( row ) {
    for (let i = 0; i < this.getColumnsNumber() - 1; i++)
        this.addTimeValueCell(row);

    this.addPercentValueCell(row);
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addEmptyColumns = function ( row ) {
    for (let i = 0; i < this.getColumnsNumber(); i++)
        ReportPreviewUtils.addEmptyCell(row);
};

BaseTasksEvAHTMLPreviewStrategy.prototype.addPercentValueCell = function( row )
{
    ReportPreviewUtils.addCell( row, "%", "percent" );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/eva/BaseTasksEvAHTMLPreviewStrategy.js